function hasSearchInitialised(callback, timeout = 5000) {
	// Poll for the textbox to be loaded.
	// We need to check that it has loaded the elements on the page before we can set the search value
	// Polling with a 5sec timeout to see if the textbox has loaded
	const startTime = Date.now();
	const poll = () => {
		const searchBox = document.querySelector('#bcs-searchbox');
		if (searchBox) {
			// Searchbox is on the page
			callback();
		} else {
			if (Date.now() - startTime > timeout) {
				console.warn('CSS did not load within the specified timeout.');
				return;
			}
			// Searchbox is not on the page, poll again in 50ms
			setTimeout(poll, 50);
		}
	};

	poll();
}

document.addEventListener('DOMContentLoaded', () => {
	// Search is in mod-search-bar, only trigger if it exists.
	if (document.querySelector('.mod-search-bar')) {
		hasSearchInitialised(() => {
			// Wait for the search box to be available.
			const searchBox = document.getElementById('bcs-searchbox');
			const submitButton = document.querySelector('.bcs-searchbox-submit');

			if (searchBox) {
				const urlParams = new URLSearchParams(window.location.search);
				const searchValue = urlParams.get('search');
				if (searchValue) {
					searchBox.value = searchValue;

					if (submitButton) {
						// Submit the form if the search value is already set.
						submitButton.click();
					}
				}
			}
		});
	}
});
